import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CompanyCommunication } from 'app/model/user/communication-preference.model';

@Component({
  selector: 'act-dialog-company-communication-text',
  templateUrl: './dialog-company-communication-text.component.html',
  styleUrls: ['./dialog-company-communication-text.component.scss']
})
export class DialogCompanyCommunicationTextComponent implements OnInit {

  public title: any;
  public message: any;

  public form: FormGroup;
  public isValidFormSubmitted = null;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: CompanyCommunication,
    public dialogRef: MdDialogRef<DialogCompanyCommunicationTextComponent>,
    private sanitizer: DomSanitizer
  ) { 
    this.buildForm();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    document.documentElement.style.setProperty('--height-vh', `${window.innerHeight * 0.01}px`);
  }

  ngOnInit() {
    if (this.data.textTemplate) {
      this.title = this.data.textTemplate.title ? this.sanitizer.bypassSecurityTrustHtml(this.data.textTemplate.title) : undefined;
      this.message = this.data.textTemplate.message ? this.sanitizer.bypassSecurityTrustHtml(this.data.textTemplate.message) : undefined;
    }
  }

  buildForm() {
    this.form = new FormGroup({
      agree: new FormControl('', Validators.requiredTrue)
    });
  }

  onFormSubmit() {
    this.isValidFormSubmitted = false;
    if (this.data.acceptingCondition && (this.form.invalid)) {
      return;
    }
    this.isValidFormSubmitted = true;
    this.dialogRef.close(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-company-communication-text/dialog-company-communication-text.component.ts